import { Routes } from '@angular/router';
import { loginGuard } from './core/guards/login.guard';
import { MAIN_ROUTES } from '@core/pages/main-layout/main-layout.routes';
import { NotFoundComponent } from '@core/components/miscellaneous/not-found.component';

export const routes: Routes = [
  ...MAIN_ROUTES,
  {
    path: 'authentication/login',
    loadComponent: () =>
      import('./core/pages/auth/login/login.component').then(
        m => m.LoginComponent,
      ),
    canActivate: [loginGuard],
  },
  {
    path: 'authentication/login/callback',
    loadComponent: () =>
      import('./core/pages/auth/login/login.component').then(
        m => m.LoginComponent,
      ),
    canActivate: [loginGuard],
  },

  {
    path: '404',
    component: NotFoundComponent,
  },
  {
    path: '**',
    redirectTo: '404',
    pathMatch: 'prefix',
  },
];
